<template>
	<div class="prazo-partes mb-10">
		<section class="column-prazo flex flex-col justify-between">
			<div class="flex flex-col mt-10 mb-4">
			<h4 class="subtitle font-bold mb-4">Partes envolvidas (Opcional)</h4>
			<h5 class="text-base font-normal">
				Digite abaixo o nome de uma pessoa envolvida no prazo e clique em “Adicionar”. Repita quantas vezes achar necessário
			</h5>
		</div>
			<div class="flex justify-between items-end pb-6 pr-2">
				<vs-input
					:disabled="disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
					class="flex-1 mr-3"
					v-model="partName"
				></vs-input>
				<ld-button
					:disabled="!partName || disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
					color="primary"
					type="border"
					@click="adicionarNovaParte"
				>
					Adicionar
				</ld-button>
			</div>
			<ul class="list-parties flex flex-col pr-2">
				<li
					class="part"
					v-for="(parte, index) in partesObj"
					:key="parte.key"
				>
					<p class="part-name">{{partesObj[index].nome}}</p>
					<feather-icon
						v-if="!disabled && !prazoDesativado && !prazoFinalizado && !prazoPerdido"
						icon="TrashIcon"
						class="part-button-delete"
						:svgClasses="`w-5 h-5 text-danger stroke-current`"
						@click="() => removerParte(index)"
					/>
				</li>
			</ul>
		</section>
	</div>
</template>


<script>
import EncryptHelper from "../../../../../../helpers/EncryptHelper";

export default {
	data() {
		return {
			partName: null,
		}
	},
	props: {
		partes: {
			required: true,
			type: Array
		},
		edicao: {
			default: false,
			type: Boolean
		},
		prazoDesativado: {
			required: true
		},
		prazoFinalizado: {
			required: true
		},
		prazoPerdido: {
			required: true
		},
	},
	computed: {
		disabled() {
			return ((!this.$permissions.can('prazomodificar') && this.edicao) || (!this.$permissions.can('prazoadicionar') && !this.edicao)) && !this.$permissions.can('autenticadosuperuser');
		},
		partesObj: {
			get() {
				return this.partes;
			},
			set(value) {
				this.$emit("update:partes", value)
			}
		}
	},
	methods: {
		adicionarNovaParte() {
			this.partesObj.unshift({
				key: EncryptHelper.encrypt("key"),
				nome: this.partName
			});
			this.partName = null;
		},
		removerParte(index) {
			this.partesObj.splice(index, 1);
		},
	}
}
</script>


<style lang="scss" src="./partes.scss"></style>
